// ************************************************************
// ************************************************************
// DATA-MYTOASTR CLASS                                            *
// ************************************************************
// ************************************************************
// La función de este objecto es mostrar mensajes con toastr.
//
// El atributo data-mytoastr es de tipo STRING y el nombre del tipo de toast a mostrar
//
// ************************************************************
// ************************************************************

import toastr from "toastr";

+function($) { 'use strict';

    // #####################################
    // Function: DataMYTOASTR
    // Definición de la Clase
    // #####################################
    var DataMYTOASTR = function(element, options) {
        this.$element       = $(element);
        this.$element.css('display', 'none')
        this.options        = $.extend({}, this.$element.data(), options);
        this.className      = 'MyToastr'; // ie9 back compat
        this.$classAlerts   = $( '[data-mytoastr-method]' , this.$element );

        this._events();
    }

    // #####################################
    // Property: DataMYTOASTR.DEFAULTS
    // Valores por defecto.
    // #####################################
    DataMYTOASTR.DEFAULTS = {
        debug: true,
        timeOut: 10000,
        positionClass: 'toast-bottom-right',
        progressBar: true,
        closeMethod:'fadeOut',
        closeDuration: 300,
        closeEasing: 'swing',
        preventDuplicates: true
    }

    /**
     * Recorremos las escenas que se han cargado.
     * @private
     */
     DataMYTOASTR.prototype._events = function() {
        this.$classAlerts.each( $.proxy( this._onLoad , this ) );
    }

    /**
     * Realiza la carga de escenas
     */
    DataMYTOASTR.prototype._onLoad = function( e ){
        var $this = this.$classAlerts,
            method = $this[e].dataset['mytoastrMethod'],
            message = $this[e].dataset['mytoastrMessage']
    
        if( typeof message == 'string' && typeof method == 'string' ){
            switch( method ){
                case 'error' || 'errors':
                    toastr.error('<p>'+message+'</p>', 'Error');
                    break
                case 'success':
                    toastr.success('<p>'+message+'</p>', 'Validación');
                    break
                case 'warning':
                    toastr.warning('<p>'+message+'</p>', 'Alerta');
                    break
                case 'info':
                    toastr.info('<p>'+message+'</p>', 'Info');
                    break
            }
           
        }
    }

    // #####################################
    // Method: DataMYTOASTR.prototype.onLoad
    // Evento del elemento
    // #####################################
    DataMYTOASTR.prototype.onLoad = function( e ){
        // e.preventDefault()
        // window.location.href = this.url
    }

    // #####################################
    // Definition: $.fn.DataHREF
    // Define la clase como plugin de jQuery
    // #####################################
    var oldDataMYTOASTR = $.fn.datamytoastr
    $.fn.datamytoastr = function (options) {
        return this.each(function(){
            var $this   = $(this)
            var data    = $this.data('bs.datamytoastr')
            if(options) {
                var option  = options
            } else {
                var option  = $this.data('mytoastr')
            }
            if (!data) $this.data('bs.datamytoastr', ( data = new DataMYTOASTR(this, option) ))
        })
    }
    $.fn.datamytoastr.Constructor = DataMYTOASTR

    // #####################################
    // Definition: $.fn.DataMYTOASTR.noConflict
    // Resuelve el conflicto que pueda terner
    // con otras biblitecas que actuan bajo $
    // #####################################
    $.fn.datamytoastr.noConflict = function () {
        $.fn.datamytoastr = DataMYTOASTR
        return this
    }

    $(window).on( 'load' , function() {
        if( $('[data-mytoastr]').length > 0 ){
            $('[data-mytoastr]').datamytoastr()
        } else {
            console.warn( '... No hay elementos para ejecutar DataMYTOASTR' )
        }
    })
}(jQuery);